/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Requirements_TitleInputs */

const en_company_profile_requirements_title = /** @type {(inputs: Company_Profile_Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicant Requirements`)
};

const de_company_profile_requirements_title = /** @type {(inputs: Company_Profile_Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anforderungen an Bewerber`)
};

/**
* | output |
* | --- |
* | "Applicant Requirements" |
*
* @param {Company_Profile_Requirements_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_requirements_title = /** @type {((inputs?: Company_Profile_Requirements_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Requirements_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_requirements_title(inputs)
	return en_company_profile_requirements_title(inputs)
});